const initialValue = {
    list: {},
    loading: false
};

export default function notificationReducer(state = initialValue, action) {
    switch (action.type) {
        case "LIST_PCB_PENDING": {
            return {...state, loading: true};
        }
        case "LIST_PCB_REJECTED": {
            return {...state, loading: false};
        }
        case "LIST_PCB_FULFILLED": {
            return {...state, list: action.payload, loading: false};
        }
        case "USER_LOGOUT_FULFILLED": {
            return initialValue;
        }
        default:
            return state
    }
}
